import {createSelector} from 'reselect';
import props from '../../../props';

export default createSelector(
    props.wheel.history.all,
    (history) => {
        return {
            history
        }
    }
)